type Translation = { language: string; title: string };

export const getTranslatedTitle = (
  translations: readonly Translation[] | undefined,
  ...preferredLanguages: (string | undefined)[]
) => {
  for (const language of preferredLanguages) {
    const match = translations?.find((translation) => translation.language === language);
    if (match) {
      return match.title;
    }
  }
  return translations?.[0]?.title;
};

export const getTitleLanguage = (
  translationLists: readonly (readonly Translation[])[],
  preferredLanguage: string,
  fallbackLanguage: string,
) =>
  translationLists.every((translations) =>
    translations.some((translation) => translation.language === preferredLanguage),
  )
    ? preferredLanguage
    : fallbackLanguage;
